import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { IUser } from '@/api/routes/users/types';

import { fetchUsers } from './actionCreators';

interface InitialState {
  users: IUser [],
  isLoading: boolean,
  error: string,
}

const initialState: InitialState = {
  users: [],
  isLoading: false,
  error: '',
};

export const usersSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {
    removeUser: (state, action: PayloadAction<string>) => {
      const deletedId = action.payload;
      state.users = state.users.filter((user) => user.id !== deletedId);
    },
  },
  extraReducers: {
    [fetchUsers.fulfilled.type]: (state, action: PayloadAction<IUser []>) => {
      state.isLoading = false;
      state.error = '';
      state.users = action.payload;
    },
    [fetchUsers.pending.type]: (state) => {
      state.isLoading = true;
    },
    [fetchUsers.rejected.type]: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export const { removeUser } = usersSlice.actions;
export default usersSlice.reducer;
